import { FormActionButton } from '@workwave-tidal/core/form'

import * as OrderTexts from '../../../../intl'
import { form } from '../formState'

type Props = {
  planLocked: boolean
  handleCancel: () => void
}

export function Footer(props: Props) {
  const { planLocked, handleCancel } = props
  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled = planLocked || status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={OrderTexts.getCancelText()}
        onClick={handleCancel}
        testId="footer-secondary-button"
        data-trackid="footer-secondary-button"
      />
      <FormActionButton
        label={OrderTexts.getFormSaveText()}
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
        testId="footer-primary-button"
        data-trackid="footer-primary-button"
      />
    </>
  )
}
